import { generateReadActionCreator } from "actions/crudActionCreators";
import ACTION_NAMES from "actions/ACTION_NAMES";
import routes from '../routes';

export default {
    getConversionData: generateReadActionCreator(`${routes.API_USER_DASHBOARD}/conversion`, ACTION_NAMES.USER_CONVERSION_DATA),
    getFunnelData: generateReadActionCreator(`${routes.API_USER_DASHBOARD}/funnel`, ACTION_NAMES.USER_FUNNEL_DATA)
}
